module.exports = __webpack_public_path__ + "html/section-vertical-text-video_a9f6059dca4d20c6c5b356ae77315778.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-vertical-text-video.html
// module id = Q247
// module chunks = 56